import React from 'react';
import SubmissionDetails from '../../../SubmissionDetails';
import { DetailsProps } from '../types';
import StatBlock from '../_partials/StatBlock';

import s from './Status.scss';

export const StatusDetails: React.FC<DetailsProps> = ({
  deviation,
  deviation: { textContent },
}) => {
  if (!textContent) {
    return null;
  }
  return (
    <div className={s['root']}>
      <SubmissionDetails deviation={deviation} className={s['details-block']} />
      <StatBlock deviation={deviation} />
    </div>
  );
};
StatusDetails.displayName = 'StatusDetails';

export default StatusDetails;
